import React from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Button from "../../shared/Button/Button";
import routeConstant from "../../../lib/constants/routeConstant";
import { selectActionAndPlayerStyles as styles } from "../deployToken.tailwind";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

// Selection container of Choose your action/ player
const Selection = ({
  stepNumber,
  heading,
  buttonText,
  images,
  selectedImage,
  onImageSelect,
  onNext,
  onBack,
  isDeployed,
  isDisabled,
}) => {
  const navigate = useNavigate();
  const { deployTokenLoading } = useSelector((state) => state.deployToken);

  const handleImageClick = (image) => {
    onImageSelect(image); // Call parent's handler when an image is clicked
  };

  const handleNavigation = () => {
    // dispatch(setMyAccountActiveTab(MY_ACCOUNT_TABS.REDEEM_REWARDS));
    navigate(routeConstant.MY_ACCOUNT_PAGE);
  };

  return (
    <div className={styles.outerContainer}>
      <div className={styles.topContainer}>
        <div className={styles.stepNumber}>{stepNumber}</div>
        <div className={styles.heading}>{heading}</div>
          {/* Handle on back-button */}
          <Button
            variant="primary"
            onClick={onBack}
            className={styles.backButton}
            disabled={deployTokenLoading}
          >
            <ArrowBackIosIcon sx={{ md: { fontSize: "16px" }, fontSize: "11px" }} />
            <span className={styles.backButtonText}>Back</span>
          </Button>
        </div>

      {/* This Heading will be visible in small devices only */}
      <div className={styles.subHeading}>
        <h2>{heading}</h2>
      </div>

      {/* Images */}
      <div className={styles.selection}>
        {images.map((image, index) => (
          <SelectionCard
            image={image}
            key={index}
            selectedImage={selectedImage}
            handleImageClick={handleImageClick}
            isDeployed={isDeployed}
          />
        ))}
      </div>

      {/* Lower Button (Next/ Deplpoy/ Go to My Account) */}
      <div className={styles.buttonContainer}>
        {/* My Account Button Rendered on the basis of if the token is deployed or not */}
        {isDeployed && stepNumber === "Step 2" && (
          <Button
            variant="secondary"
            onClick={handleNavigation}
            className={styles.dynamicButton}
          >
            <ArrowBackIosIcon
              sx={{ md: { fontSize: "16px" }, fontSize: "11px" }}
            />
            <span className={styles.buttonText}>Back to My Account</span>
          </Button>
        )}

        {/* "Next" button */}
       {!isDisabled || deployTokenLoading ? (
          <Button
            variant="primary"
            onClick={onNext}
            disabled={isDisabled || !selectedImage}
            className={`${styles.dynamicButton} ${!isDeployed ? "ml-auto" : ""}`}
          >
            <span className={styles.buttonText}>{buttonText}</span>
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default React.memo(Selection);

const SelectionCard = ({ selectedImage, image, handleImageClick, isDeployed }) => {
  const isSelected = selectedImage?.id === image?.id; // Check if the image is selected

  return (
    <div
      className={`${styles.imageContainer} ${(isSelected && selectedImage) ? styles.selectedImage : ""}`}
      onClick={() => handleImageClick(image)}
    >
      {/* image */}
      <img src={image?.src} alt={image?.alt} className={styles.image} />

      {/* overlay */}
      <div
        className="absolute top-0 left-0 w-full h-full"
        style={{
          background: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 69.84%, rgba(0, 0, 0, 0.55) 87%, rgba(0, 0, 0, 0.80) 99.61%)`,
        }}
      />

      {/* image-text (player name/ action name) */}
      <div className={styles.imageText}>{image?.text}</div>
    </div>
  );
};
